import { SVGComponentProps } from "./utils/Types"

const ConnectionsIcon = ({ width = 14, height = 14, className }: SVGComponentProps) => {
    return (
        <svg
            className={`text-current ${className}`}
            width={width}
            height={height}
            viewBox="0 0 14 14"
            fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.75 0.75V0H2.25V0.75V8.09451C0.95608 8.42754 0 9.6021 0 11C0 12.6569 1.34315 14 3 14C4.42051 14 5.61042 13.0127 5.921 11.6869C7.37102 11.4872 8.7262 10.8197 9.773 9.773C10.8197 8.7262 11.4872 7.37102 11.6869 5.921C13.0127 5.61042 14 4.42051 14 3C14 1.34315 12.6569 0 11 0C9.3431 0 8 1.34315 8 3C8 4.37069 8.91924 5.52667 10.1749 5.8851C9.9929 6.94904 9.4857 7.9389 8.71231 8.71231C7.9389 9.4857 6.94904 9.9929 5.8851 10.1749C5.59439 9.1565 4.77903 8.35937 3.75 8.09451V0.75ZM12.5 3C12.5 3.82843 11.8284 4.5 11 4.5C10.1716 4.5 9.5 3.82843 9.5 3C9.5 2.17157 10.1716 1.5 11 1.5C11.8284 1.5 12.5 2.17157 12.5 3ZM3 12.5C3.82843 12.5 4.5 11.8284 4.5 11C4.5 10.1716 3.82843 9.5 3 9.5C2.17157 9.5 1.5 10.1716 1.5 11C1.5 11.8284 2.17157 12.5 3 12.5Z"
                fill="currentColor"
            />
        </svg>
    )
}

export default ConnectionsIcon
